import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { injectIntl } from 'react-intl';
import CSSModules from 'react-css-modules';

import * as appointmentProgressConsents from '../../../redux/appointmentForm/requests/consent-req';
import * as locations from '../../../redux/appointmentForm/requests/filters-req';
import { appointmentProgressActions } from '../../../redux/appointmentForm/progress-types';
import { appointmentFilterActions } from '../../../redux/appointmentForm/filters';
import withCareUserSubtitle from '../hocs/withCareUserSubtitle';
import {
  selectAppointmentDateFilter,
  selectScheduleMetaDataFromProviderList,
  selectAppointmentFilterList,
  selectAppointmentLocationFilter,
  selectAppointmentFilterPending,
  selectAvailableProvidersSelfScheduling,
  selectAvailableProvidersSelfSchedulingLoading,
  selectFilterPayloadData,
  selectProgressVisitType,
  selectIsEirVisitTypeCode,
  selectAvailableEirLocationLoading,
  selectAvailableEirLocationsData,
} from '../../../redux/appointmentForm/selectors';
import {
  OFFICE_VISIT_TYPE_CODE,
  VIRTUAL_VISIT_TYPE_CODE,
} from '../../../constants';

import styles from './styles.styl';

const mapStateToProps = state => ({
  activeDate: selectAppointmentDateFilter(state),
  activeLocations: selectAppointmentLocationFilter(state),
  availableSelfSchedulingLocations: selectAvailableProvidersSelfScheduling(
    state,
  ),
  filterList: selectAppointmentFilterList(state),
  filterLoading: selectAppointmentFilterPending(state),
  filterPayload: selectFilterPayloadData(state),
  isEirVisitType: selectIsEirVisitTypeCode(state),
  providersLoading: selectAvailableProvidersSelfSchedulingLoading(state),
  eirLocations: selectAvailableEirLocationsData(state),
  eirLocationsLoading: selectAvailableEirLocationLoading(state),
  scheduleMeta: selectScheduleMetaDataFromProviderList(state),
  visitType: selectProgressVisitType(state),
});

const mapDispatchToProps = {
  setDateFilter: appointmentFilterActions.setDate,
  setLocationFilter: appointmentFilterActions.setLocation,
  setScheduleData: appointmentProgressActions.setScheduleData,
  fetchProviderList: appointmentProgressActions.fetchProviderList,
  clearProgressConsents: appointmentProgressConsents.actions.clear,
  fetchLocationsReq: locations.actions.send,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withProps(
    ({
      availableSelfSchedulingLocations,
      eirLocations,
      eirLocationsLoading,
      fetchLocationsReq,
      filterLoading,
      filterPayload,
      isEirVisitType,
      providersLoading,
      visitType,
    }) => {
      const locationsMap = new Map([[isEirVisitType, eirLocations]]);

      const visitTypeCode = get(visitType, 'code');

      return {
        loading: filterLoading || providersLoading || eirLocationsLoading,
        fetchLocations: () => {
          fetchLocationsReq(filterPayload);
        },
        isOfficeVisit: visitTypeCode === OFFICE_VISIT_TYPE_CODE,
        isVirtualVisit: visitTypeCode === VIRTUAL_VISIT_TYPE_CODE,
        locationList:
          locationsMap.get(true) || availableSelfSchedulingLocations,
      };
    },
  ),
  withCareUserSubtitle,
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/AppointmentProviders/enhance.js